import { BASE_API_URL } from '@env';
import { useQuery } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { Event } from '~types/api/event';
import axios from 'axios';

export const useGetPyxiSelectEvents = (eventId?: string | number) => {
  
  return useQuery<Event[], Error>(
    ['_getPyxiSelectEvents', eventId],
    async () => {
        const token = useUserStore.getState().token;
      if (!token) {
        throw new Error('No authentication token available');
      }

      console.log('🔍 useGetPyxiSelectEvents: Making API call with token:', token ? 'EXISTS' : 'MISSING');
      
      // Build the API URL with optional event_id parameter
      const baseUrl = `${BASE_API_URL}events/pyxi-select/available`;
      const apiUrl = eventId ? `${baseUrl}?event_id=${eventId}` : baseUrl;
      
      console.log('🔍 useGetPyxiSelectEvents: API URL:', apiUrl);

      const config = {
        headers: { 
          Authorization: token, 
          Accept: 'application/json' 
        },
      };

      try {
        const response = await axios.get(apiUrl, config);
        console.log('🔍 useGetPyxiSelectEvents: API Response:', response.data);
        return response.data;
      } catch (error) {
        console.error('🔍 useGetPyxiSelectEvents: API Error:', error);
        if (axios.isAxiosError(error)) {
          throw new Error(`Failed to fetch available events: ${error.response?.status} - ${error.response?.data?.message || error.message}`);
        }
        throw new Error('Failed to fetch available events');
      }
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    }
  );
};
